import { NetworkingError } from "services/ApiClient/networkingError";
import UnfoundResource from "components/Error/UnfoundResource";
import UnknownError from "components/Error/UnknownError";

interface QueryErrorProps {
  queryError: any;
  id: string;
  resourceName: string;
}

export default function QueryError({ queryError, id, resourceName }: QueryErrorProps) {
  return (queryError as NetworkingError)?.status === 404 ? (
    <UnfoundResource resourceName={resourceName} />
  ) : (
    <UnknownError resourceId={id} resourceName={resourceName} />
  );
}
